import { getValidationMessages } from '@/common/constants/validation-messages';
import * as yup from 'yup';

const messages = getValidationMessages();

export const GeneralGrainSchema = yup.object().shape({
  tax_number: yup.string().required(messages.required),
  farmer_contract_id: yup.string().required(messages.required),
  crop_type_id: yup.string().required(messages.required),
});
